import { QueryFunction, useInfiniteQuery } from "react-query";
import { QueryKeys } from "../common/queryKeys";
import { IApiPage, IUserProfile } from "../common/commonTypes";
import { usersService } from "../api/usersService";
import { nextPageParamGetter } from "../helpers/paginationHelper";

const ARTISTS_PAGE_SIZE = 20;

export const fetchArtistsPage: QueryFunction<IApiPage<IUserProfile>> = async ({
  pageParam,
}) => {
  const response = await usersService.fetchArtists({
    offset: pageParam || 0,
    limit: ARTISTS_PAGE_SIZE,
    order: [["username", "ASC"]],
  });
  return response.data;
};

export const useArtistsQuery = () => {
  return useInfiniteQuery<IApiPage<IUserProfile>>(
    QueryKeys.artists,
    fetchArtistsPage,
    {
      getNextPageParam: nextPageParamGetter(ARTISTS_PAGE_SIZE),
    }
  );
};
